export default __webpack_public_path__ + "static/media/headphones.5c75bd23.svg";